import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * ScrollToTop — controls scroll behaviour on every route change,
 * including browser Back / Forward navigations.
 *
 * - Disables the browser's default scroll restoration so React Router
 *   is fully in charge of where the viewport lands.
 * - Plain path change   → instant scroll to (0, 0)
 * - Path change + hash  → smooth-scroll to that anchor after it mounts
 * - Back / Forward      → treated like any other navigation (top of page,
 *   or hash target if one is present)
 */
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType(); // "PUSH" | "REPLACE" | "POP"

  useEffect(() => {
    if (hash) {
      const id = hash.startsWith("#") ? hash.slice(1) : hash;
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 20) {
          setTimeout(() => tryScroll(attempt + 1), 60);
        }
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, navType]);

  return null;
}
